import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger"; 
gsap.registerPlugin(ScrollTrigger); 

export default class Anchors {

  constructor(el) {
    this.el = el;
 
    this.elms = {
      container : this.el.querySelector('.hwc-Anchors'),
      anchors: this.el.querySelectorAll("[data-anchors-item]"), 
    }   
 
    this.anchors = {  
      height : this.elms.container.getBoundingClientRect().height,
      top : this.elms.container.getBoundingClientRect().top + window.scrollY,
      limit : this.elms.container.getBoundingClientRect().top + this.el.getBoundingClientRect().height + window.scrollY,
      state : false,
    }    

    this.init(); 
  }


  init(){  
    if (this.elms.anchors) { 
      this.getSections();     
      document.addEventListener("scroll", (e) => this.onScroll(e));
      this.onScroll();

      this.elms.anchors.forEach((anchor) => {
        anchor.addEventListener("click", (e) => this.onClick(anchor.dataset.anchorsItem));
      });
    }  
  } 

  onClick(value){
     if( document.querySelector('.is-anchors-sticky .hwc-Anchors') ){ 
      this.anchors.height = this.elms.container.getBoundingClientRect().height;
    }

    if(document.querySelector(`[data-anchors-section="${value}"]`)){
      const offset = ( this.anchors.height ) * -1;  
      const posTop = document.querySelector(`[data-anchors-section="${value}"]`).getBoundingClientRect().top + window.scrollY + offset;
      gsap.to(window, { duration: 1, ease : "power4.out", scrollTo: { y: posTop }}); 
    }
  }
 
  onScroll() {     
    this.getSections();   
    this.getActiveSection();
    this.setActiveSection();
    this.setSticky(); 
 
  }

  getActiveSection() { 
    for (let i = 0; i < this.elms.sections.length; i++) {
      const current = this.elms.sections[i]; 
      const limit = window.scrollY + window.innerHeight * 0.5;   
      
      if (limit > current.top && limit < current.bottom) { 
        this.activeSection = current.el;
        break;
      } 
    } 
  }

  setActiveSection() {
 
    this.elms.anchors.forEach((anchor) => {
  
      anchor.classList.remove("is-active"); 
      
      //active
      if(this.activeSection){
        const id = this.activeSection.dataset.anchorsSection;
        if (id && anchor.dataset.anchorsItem == id && !anchor.classList.contains("is-active")) {
          anchor.classList.add("is-active"); 

          if( window.innerWidth < 1024 ){
            const container = this.elms.container.querySelector('.hwc-Anchors-container');
            const posLeft = anchor.getBoundingClientRect().left + container.scrollLeft - 16;  
            gsap.to(container, { duration: 0.6, ease : "power4.out", scrollTo: { x: posLeft }}); 
          }
        } 
      }  
    }); 
  }

  getSections() {
    let sections = [];

    const indexEnd = this.elms.anchors.length - 1;  
     
    this.elms.anchors.forEach((anchor, index) => {  
      if (anchor.dataset.anchorsItem) { 
 
        //Section
        const section = {};
        section.el = document.querySelector(`[data-anchors-section="${anchor.dataset.anchorsItem}"]`);

        if(section.el){ 

          section.top = Math.round(section.el.getBoundingClientRect().top + window.scrollY - this.anchors.height);
          section.bottom = Math.round(section.el.getBoundingClientRect().height + section.el.getBoundingClientRect().top + window.scrollY - this.anchors.height - 1);
        
          //Next section
          const section_next = {
            el : false,
            top :false, 
          }  
          if(this.elms.anchors[index + 1]){
            section_next.el = document.querySelector(`[data-anchors-section="${this.elms.anchors[index + 1].dataset.anchorsItem}"]`);
            section_next.top = Math.round(section_next.el.getBoundingClientRect().top + window.scrollY - this.anchors.height - 1);
          }

          //Body
          const bodyBottom = Math.round( document.body.getBoundingClientRect().height + window.scrollY - this.anchors.height - 1);
          
          /*  si c'est le premier bloc alors top = 0 */
          /*  si c'est le dernier bloc alors bottom = body bottom */
          /*  si il y a un bloc après il faut que le bottom soit égale au top du bloc suivant */  
          const data = {
            el: section.el, 
            top: ( index == 0 ) ? 0 : section.top,
            bottom: (index == indexEnd ) ? bodyBottom : ( section_next.el ? section_next.top : section.bottom),
          };

          sections.push(data);
        }
      }
    }); 

    this.elms.sections = sections;
  }

  setSticky(){

    const stickyEl = (window.innerWidth < 1024) ? document.querySelector("[data-sticky-mobile]") : document.querySelector("[data-sticky-desktop]"); 
  
    ScrollTrigger.create({
      start: "top top",
      end: "bottom top",
      onUpdate: () => {   
   
        //Quand ma fenêtre est entre la fin de mon bloc + 100 et la fin de mon bloc + 200, on fixe le tout en haut de la fenêtre (fixed) et on cache ( translateY: -100% )
        if( window.scrollY > this.anchors.limit + 100 && window.scrollY < this.anchors.limit + 200 ){   

          if( this.anchors.state !== 'ready' ){  
            gsap.set(this.elms.container, { position:'fixed', yPercent: -100, y : 0, force3D: true });   
            this.anchors.state = "ready"; 
          }

        // On dépasse la fin de mon bloc ancre + 200, on anime le bloc pour qu'il apparaisse en haut de notre fenêtre
        }else if( window.scrollY > this.anchors.limit + 200 ){  

          if( this.anchors.state !== 'sticky' ){  
            this.elms.container.classList.add('is-sticky');   
            gsap.set(this.elms.container, { position:'fixed' });
            this.anchors.state = "sticky";
          }

          //si le header est lui ausssi en sticky, on décale les ancres en Y en fonction de la hauteur du header
          if( stickyEl.classList.contains('is-sticky') && document.body.classList.contains('is-scroll-up') ){
            if(this.anchors.header !== 'show'){ 
                gsap.set(this.elms.container, { yPercent: 0, y: stickyEl.getBoundingClientRect().height - 1 });    
                this.anchors.header = 'show';
              }
              //sinon on affiche simplement le bloc ancre en haut de fenêtre
            }else{
              if(this.anchors.header !== 'hide'){ 
              gsap.set(this.elms.container, { yPercent: 0, y : 0, force3D: true });    
              this.anchors.header = 'hide';
            }
          }
          
          //Sinon on le remet à sa position intiale
        }else{ 
          
          if( this.anchors.state !== 'initial' ){  
            this.elms.container.classList.remove('is-sticky');  
            gsap.set(this.elms.container, { position:'relative', yPercent: 0, y : 0, force3D: true }); 
            this.anchors.state = "initial";
          }
 
        }    

      }
    });


  } 
}